import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "../../constants/common/StyledGlobalConstants";
import { RadioButtonGroup } from "@vds/radio-buttons";
import "./myContract.css";

const RadioCard = ({ id, values, handleChange, defaultValue, ariaLabel }) => {
  return (
    <Wrapper display="flex" alignItems="center" gap="1.5rem" width="100%">
      <RadioButtonGroup
        tabIndex="0"
        ariaLabel={ariaLabel}
        defaultValue={defaultValue?.length === 0 ? "none" : defaultValue}
        id={id}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        error={false}
        data={values}
      ></RadioButtonGroup>
    </Wrapper>
  );
};
RadioCard.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  ariaLabel: PropTypes.string
};

export default RadioCard;